import { createContext } from 'react';

export interface SidebarContextValue {
  isOpen: boolean;
  onClose?: () => void;
}

export const SidebarContext = createContext<SidebarContextValue>({
  isOpen: false,
});
